function srgbToLinear(c) {
  c = c / 255
  return c <= 0.04045
    ? c / 12.92
    : Math.pow((c + 0.055) / 1.055, 2.4)
}

function relativeLuminance({ r, g, b }) {
  const R = srgbToLinear(r)
  const G = srgbToLinear(g)
  const B = srgbToLinear(b)
  return 0.2126 * R + 0.7152 * G + 0.0722 * B
}

function hexToRgb(hex) {
  // Remove leading "#"
  hex = hex.replace(/^#/, '')

  // Handle shorthand "#ABC"
  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('')
  }

  // Now must be 6 chars
  if (hex.length !== 6) {
    throw new Error(`Invalid hex colour: ${hex}`)
  }

  const num = parseInt(hex, 16)
  return {
    r: (num >> 16) & 0xFF,
    g: (num >> 8) & 0xFF,
    b: num & 0xFF
  }
}

function logoTextColourSource({variables,allowAmbiguous=false}) {
  if (allowAmbiguous) {
    if (L <= 0.0398) return 'labelColor'
    if (L >= 0.0410) return 'foregroundColor'
   return 'ambiguous'
  } else {

    const backgroundColor = variables?.colours?.background ?? "#ffffff"

    const L = relativeLuminance(hexToRgb(backgroundColor))
    return L <= 0.0395 ? "labelColor" : "foregroundColor"
  }
}

export default logoTextColourSource